import React from 'react';

/**
 * Centered loading spinner. Replaces the `animate-spin` block duplicated
 * across 10 pages + App.js.
 *
 * Props:
 *   size      {string}  — Tailwind size classes (h-N w-N), default 'h-12 w-12'
 *   className {string}  — extra classes on the outer wrapper
 */
const LoadingSpinner = ({ size = 'h-12 w-12', className = '' }) => (
  <div className={`flex items-center justify-center h-64 ${className}`}>
    <div className={`animate-spin rounded-full ${size} border-b-2 border-indigo-600`} />
  </div>
);

export default LoadingSpinner;
